import React from 'react'
import { Box, Card, Typography, TypographyProps } from '@mui/material'

// Placeholder page — real content is not built out yet. This just wires up
// the route/menu entry so navigation and permissions can be tested end to end.
const Blacklist: React.FC = () => {
  return (
    <Box>
      <Box marginBottom={2}>
        <Typography variant={'title1' as TypographyProps['variant']}>
          Blacklist
        </Typography>
      </Box>
      <Card sx={{ padding: '24px 48px', borderRadius: '10px' }}>
        <Typography color='text.secondary'>Coming soon.</Typography>
      </Card>
    </Box>
  )
}

export default Blacklist
